import { Box, Typography } from "@mui/material";
import { borderRadius, colorsFoundation } from "@accredo/fe-shared/theme/index.js";
import { getDatumZeit, getEuro } from "@accredo/fe-shared/services/formatService.js";

const ListContainer = ({ children }) => {
  return (
    <Box
      sx={{
        overflow: "hidden",
      }}
    >
      {children}
    </Box>
  );
};

const MATCH_STATUS_STYLES = {
  exact: {
    label: "Exakt",
    backgroundColor: colorsFoundation.key.gold[50],
    color: colorsFoundation.key.gold[700],
  },
  possible: {
    label: "Möglich",
    backgroundColor: colorsFoundation.status.critical[50],
    color: colorsFoundation.status.critical[700],
  },
};

const PaymentMatchListItem = ({ pm, isSelected, onToggle }) => {
  const payment = pm?.payment;

  if (!payment) {
    return null;
  }

  const statusStyle = MATCH_STATUS_STYLES[pm.status] || MATCH_STATUS_STYLES.possible;

  return (
    <ListItem
      selected={isSelected}
      onClick={onToggle ? () => onToggle(payment.id) : undefined}
    >
      <Box
        sx={{
          display: "flex",
          gap: 2,
          opacity: isSelected ? 1 : 0.5,
        }}
      >
        <Box sx={{ pt: 0.5 }}>
          <input type="checkbox" readOnly checked={isSelected} />
        </Box>
        <Box sx={{ flex: 1 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              mb: 1,
            }}
          >
            <Box
              component="span"
              sx={{
                px: 1,
                py: 0.25,
                borderRadius: 999,
                fontSize: "0.75rem",
                backgroundColor: statusStyle.backgroundColor,
                color: statusStyle.color,
              }}
            >
              {statusStyle.label}
            </Box>
          </Box>
          <Typography variant="caption" color="text.secondary">
            {payment.remitter}
          </Typography>
          <Typography variant="body2">{payment.description}</Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mt: 1,
              alignItems: "center",
            }}
          >
            <Typography variant="caption" color="text.secondary">
              Datum: {getDatumZeit(payment.processed_at)}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontWeight: 600,
                color:
                  payment.debit_credit === "C" ? "green" : "error.main",
              }}
            >
              {payment.debit_credit === "C" ? "" : "-"}
              {getEuro(payment.amount)}
            </Typography>
          </Box>
        </Box>
      </Box>
    </ListItem>
  );
};

const ListItem = ({
  selected = false,
  onClick,
  showSelectionIndicator = false,
  children,
}) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        p: 2,
        borderRadius: selected ? borderRadius.sm : 0,
        border: selected
          ? `2px solid ${colorsFoundation.status.informative[500]}`
          : "2px solid transparent",
        borderBottom: selected
          ? `2px solid ${colorsFoundation.status.informative[500]}`
          : `2px solid ${colorsFoundation.neutral[200]}`,
        cursor: onClick ? "pointer" : "default",
        backgroundColor: selected ? colorsFoundation.neutral[50] : "white",
        "&:hover": {
          backgroundColor: selected
            ? colorsFoundation.neutral[50]
            : colorsFoundation.neutral[100],
        },
      }}
    >
      {selected && showSelectionIndicator ? (
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}>
          <Box sx={{ pt: 0.5 }}>
            <input type="radio" readOnly checked />
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
        </Box>
      ) : (
        children
      )}
    </Box>
  );
};

export { ListContainer, ListItem, PaymentMatchListItem };
